import { BRAND_COLORS, COLORS_BASIC, FUNCTIONAL_COLORS } from '../../dsm/color';
import { backgroundColor, borderColor, brandColor, palette, textColor } from '../../dsm/color-token';
export const engagementAnalyticsProductColorToken = {
  'product-color': '#003B8A',
  'product-color-light-100': '#398CFB',
  'product-color-light-200': '#72AEFC',
  'product-color-light-300': '#ABD0FD',
  'product-color-light-400': '#E5F0FF',
  'product-color-dark-100': '#054AD1',
  'product-color-dark-200': '#003B8A',
  'product-color-dark-300': '#002352',
  'product-color-dark-400': '#000B1A'
};
export const engagementAnalyticsBackgroundColor = {
  'color-background-page': palette['palette-grey-light-200']
};
const componentsColor = {
  'color-charts-primary': engagementAnalyticsProductColorToken['product-color-dark-100'],
  'color-charts-secondary': engagementAnalyticsProductColorToken['product-color-light-300']
};
export const engagementAnalyticsColor = {
  COLORS_BASIC,
  COLORS: { // eslint-disable-next-line deprecation/deprecation
    ...BRAND_COLORS,
    // eslint-disable-next-line deprecation/deprecation
    ...FUNCTIONAL_COLORS
  },
  colors: { ...engagementAnalyticsProductColorToken,
    ...palette,
    ...backgroundColor,
    ...textColor,
    ...borderColor,
    ...componentsColor,
    ...brandColor,
    ...engagementAnalyticsBackgroundColor
  }
};